import React from 'react';
import { useFela, Style } from '../../..';
import { LoadingAnimationProps } from '../LoadingAnimationProps';

const EGG_COLOR = '#A2D5D7';
const DECO_COLOR = '#ffffff';

const eggStyle: Style = {
  mixBlendMode: 'luminosity',
  fill: EGG_COLOR,
  fillOpacity: 1,
  fillRule: 'evenodd',
  stroke: EGG_COLOR,
  strokeWidth: '7.55906',
  strokeMiterlimit: 4,
  strokeDasharray: 'none',
  strokeOpacity: 1,
  paintOrder: 'markers stroke fill',
};

const decoUpperStyle: Style = {
  fill: DECO_COLOR,
  fillOpacity: 1,
  stroke: 'none',
  strokeWidth: '0.264583px',
  strokeLinecap: 'butt',
  strokeLinejoin: 'miter',
  strokeOpacity: 1,
};

const decoLowerStyle: Style = {
  fill: DECO_COLOR,
  fillOpacity: 1,
  stroke: 'none',
  strokeWidth: '0.237574px',
  strokeLinecap: 'butt',
  strokeLinejoin: 'miter',
  strokeOpacity: 1,
};

const spinning = () => ({
  '0%': {
    transform: 'rotate(0deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
});

const spin = (renderer: any) => {
  const animation = renderer.renderKeyframe(spinning, {});

  return {
    animationName: animation,
    animationDuration: '2000ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    margin: 'auto',
  };
};

const EasterEgg = ({
  size,
  dmId = 'dm-easteregg',
  id,
  title,
  description,
}: LoadingAnimationProps): JSX.Element => {
  const { css, renderer } = useFela();

  // Accessibility attributes
  const TITLE_ID = `${id || dmId}Title`; // todo: dmId should be removed, as soon as id prop is required (myt-7757)
  const DESC_ID = description ? ` ${id || dmId}Desc` : ''; // todo: dmId should be removed, as soon as id prop is required (myt-7757)
  const ARIA_LABELLEDBY = `${TITLE_ID}${DESC_ID}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size * 1.5}
      height={size * 1.5}
      viewBox="0 0 50 80"
      className={css(spin(renderer))}
      aria-labelledby={ARIA_LABELLEDBY}
      role="img">
      <title id={TITLE_ID}>{title}</title>
      {description && <desc id={DESC_ID}>{description}</desc>}
      <g>
        <g transform="translate(-27,-15)">
          <path
            className={css(eggStyle)}
            d="m 115.25179,246.44332 c -1.09416,-5.02933 -1.45486,-10.35409 -1.38421,-20.43445 0.43749,-62.42342 26.10183,-115.63868 65.30101,-135.402279 13.59085,-6.85229 25.34149,-6.873475 38.83506,-0.07001 28.64738,14.444009 51.07091,47.872329 60.4683,90.144329 4.25854,19.15607 5.14439,27.77226 5.14403,50.03349 -0.78901,55.01141 -26.98539,95.12736 -82.8339,97.09653 -55.25129,-1.29571 -75.79759,-41.48333 -85.53029,-81.36761 z"
            transform="scale(0.26458333)"
          />
          <path
            className={css(decoUpperStyle)}
            d="m 36.882133,34.079527 c 9.328385,2.695406 23.145595,3.398119 31.743932,0.679853 1.590885,2.766804 1.822061,3.343384 2.555229,5.100305 -6.523244,3.513639 -27.440842,8.999348 -39.175678,5.700617 1.971538,-6.971966 3.379341,-9.107644 4.876517,-11.480775 z"
          />
          <path
            className={css(decoLowerStyle)}
            d="m 74.109405,69.880441 c -7.933755,9.769855 -30.177524,10.932626 -38.434518,7.871122 -2.783499,-3.43635 -4.188121,-7.8796 -5.115052,-12.253915 11.782333,6.282557 33.740531,7.622922 44.466045,-1.236036 0.0011,2.54013 -0.271897,3.548813 -0.916475,5.618829 z"
          />
        </g>
      </g>
    </svg>
  );
};

export default EasterEgg;
